import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Container,
  Divider,
  Flex,
  Heading,
  HStack,
  SkeletonText,
  Stack,
  Table,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import ButtonEmailPreview from "components/ButtonEmailPreview";
import DateTime from "components/ui/DateTime";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import InfoList from "components/ui/InfoList";
import TagEmailStatus from "components/ui/TagEmailStatus";
import EmailSentStats from "features/reports/components/EmailSentStats";
import { useResource } from "hooks/useResource";
import { useLocation, useParams } from "react-router-dom";
import TagOnlyNewsletter from "../components/TagOnlyNewsletter";
import { LinkContentPreview } from "../config";

export default function PageReportDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { data: report, isLoading } = useResource({
    id: id as string,
    resourceName: "content",
    path: "content-send-report",
  });

  return (
    <>
      <HeaderBarInternal
        title="Visualizar Disparo de Report"
        backTo={`/disparos-de-report${location.search}`}
      ></HeaderBarInternal>

      <Divider />

      <Container variant="internal" flexDirection="column" mb="80px">
        <SkeletonText isLoaded={!isLoading}>
          {report && (
            <>
              <Card>
                <CardHeader>
                  <Flex alignItems="center">
                    <Stack spacing="5px" alignItems="flex-start" mr="25px">
                      <Heading as="h3" size="h3">
                        {report.title}
                      </Heading>
                      {report.isOnlyNewsletter && <TagOnlyNewsletter ml={0} />}
                      <TagEmailStatus record={report} />
                    </Stack>
                    <ButtonEmailPreview url={LinkContentPreview(report)} />
                  </Flex>
                </CardHeader>
                <CardBody>
                  <InfoList
                    mt="10px"
                    ml={0}
                    justifyContent="flex-start"
                    spacing="35px"
                  >
                    <Box>
                      <Text as="span">
                        <small>Criado por</small>
                        {report.createdBy.name}
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Modelo de disparo</small>
                        {report.contentGroup.name}
                      </Text>
                    </Box>
                  </InfoList>

                  <InfoList
                    mt="25px"
                    ml={0}
                    justifyContent="flex-start"
                    spacing="35px"
                  >
                    <Box>
                      <Text as="span">
                        <small>Assunto do e-mail</small>
                        {report.subject}
                      </Text>
                    </Box>

                    <Box>
                      <Text as="span">
                        <small>Criado em</small>
                        <DateTime date={report.createdAt} noBreak />
                      </Text>
                    </Box>
                    {report.email && (
                      <Box>
                        <Text as="span">
                          <small>Enviado em</small>
                          <DateTime date={report.email.createdAt} noBreak />
                        </Text>
                      </Box>
                    )}
                  </InfoList>

                  {report.email && (
                    <InfoList
                      mt="25px"
                      ml={0}
                      justifyContent="flex-start"
                      spacing="35px"
                    >
                      <Box>
                        <Text as="span">
                          <small>Destinatários</small>
                          {report.email.countRecipients}
                        </Text>
                      </Box>
                      <Box>
                        <Text as="span">
                          <small>Enviados</small>
                          {report.email.countSent}
                        </Text>
                      </Box>
                      <Box>
                        <Text as="span">
                          <small>Bounce</small>
                          {report.email.countBounce}
                        </Text>
                      </Box>
                    </InfoList>
                  )}
                </CardBody>
              </Card>

              {report.lists.length > 0 && (
                <Card mt="30px">
                  <CardHeader>
                    <Heading as="h3" size="h3">
                      Listas
                      <Text as="span"></Text>
                    </Heading>
                  </CardHeader>
                  <CardBody>
                    <Table>
                      <Thead>
                        <Tr>
                          <Th>Empresa</Th>
                          <Th>Lista</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {report.lists.map((list) => (
                          <Tr key={list.id}>
                            <Td>{list.company.name}</Td>
                            <Td>
                              {list.name}
                              {list.isNewsletter && (
                                <Tag
                                  colorScheme="green"
                                  ml="10px"
                                  verticalAlign="center"
                                >
                                  Newsletter
                                </Tag>
                              )}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </CardBody>
                </Card>
              )}

              {report.email && (
                <Card mt="30px">
                  <CardHeader>
                    <Heading as="h3" size="h3">
                      Estatísticas de envio
                    </Heading>
                  </CardHeader>
                  <CardBody>
                    <EmailSentStats email={report.email} />
                  </CardBody>
                </Card>
              )}
            </>
          )}
        </SkeletonText>
      </Container>
    </>
  );
}
